import { Button } from "flowbite-react";
import React from "react";
import { HiChevronLeft } from "react-icons/hi";
class ErrorBoundary extends React.Component {
  constructor(props: {} | Readonly<{}>) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: any) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error: any, errorInfo: any) {
    // You can also log the error to an error reporting service
  }

  render() {
    if (this.state.hasError) {
      return <div className="flex min-h-screen flex-col items-center justify-center py-16 ">
        <div className="max-w-xl flex flex-col items-center justify-center">
          <img alt="" src="/images/illustrations/404.svg" className="lg:max-w-lg" />
          <h1 className="mb-6 text-2xl font-bold text-slate-900 dark:text-white md:text-5xl">
            Something went Wrong
          </h1>
          <p className="mb-6 w-4/5 text-center text-lg text-gray-500 dark:text-gray-300">
            Oops! Looks like you followed a bad link or you do not have access to it. If you think this is a problem
            with us, please tell us.
          </p>
          <p  className="mb-6 w-4/5 text-center text-lg text-gray-500 dark:text-gray-300">
            support@cadencepro.ai
          </p>
          <Button href="/" className="w-48">
            <div className="mr-1 flex items-center gap-x-2">
              <HiChevronLeft className="text-xl" /> Go back home
            </div>
          </Button>
        </div>
    </div>;
    }

    return this.props.children; 
  }
}

export default ErrorBoundary;